import { memo, useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import camelCase from 'lodash/camelCase';
import includes from 'lodash/includes';
import kebabCase from 'lodash/kebabCase';
import upperFirst from 'lodash/upperFirst';
import * as modals from 'modals';
import Modal from 'antd/lib/modal/Modal';

import useModal from 'hooks/useModal';
import { EModalsNames } from 'modals/constants';
import { STORAGE_KEYS } from 'utils/constants/constants';

const isNotClosableModals = [EModalsNames.TellUs];

const ModalComponent = () => {
  const { search } = useLocation();
  const setModal = useModal();
  const modalName = upperFirst(camelCase(new URLSearchParams(search).get('modal_name') || '')) as EModalsNames;
  const modalProps = JSON.parse(sessionStorage.getItem(STORAGE_KEYS.modalProps) || '{}');
  const isClosable = !includes(isNotClosableModals, modalName);

  const handleModalClose = useCallback(() => {
    setModal({});
  }, [search]);

  const Component = useMemo(() => modals[modalName] || (() => null), [modalName]);

  return (
    <Modal
      centered
      destroyOnClose
      width="auto"
      footer={null}
      open={!!modalName}
      closable={isClosable}
      maskClosable={isClosable}
      onCancel={handleModalClose}
      className={`${kebabCase(modalName)}-modal`}
    >
      <Component {...modalProps} onModalClose={handleModalClose} />
    </Modal>
  );
};

export default memo(ModalComponent);
